import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, resolveComponent as _resolveComponent, createElementVNode as _createElementVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "page-content full-height" }
const _hoisted_2 = { class: "full-height" }

import { provide, ref } from "vue";
import TopToolbar from "./blocks/TopToolbar.vue";
import { SCROLL_TARGET_INJECTION_KEY } from "../constants";


export default /*@__PURE__*/_defineComponent({
  __name: 'MainComponent',
  setup(__props) {

const container = ref<HTMLElement | undefined>();

const wrapperStyleFn = (offset: number) => ({
  height: offset ? `calc(100vh - ${offset}px)` : "100vh",
});

provide(SCROLL_TARGET_INJECTION_KEY, container);

return (_ctx: any,_cache: any) => {
  const _component_router_view = _resolveComponent("router-view")!
  const _component_d_page = _resolveComponent("d-page")!

  return (_openBlock(), _createBlock(_component_d_page, {
    "style-fn": wrapperStyleFn,
    class: "drv-p-4"
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createVNode(TopToolbar),
          _createElementVNode("div", {
            ref_key: "container",
            ref: container,
            class: "page-content-wrapper"
          }, [
            _createVNode(_component_router_view)
          ], 512)
        ])
      ])
    ]),
    _: 1
  }))
}
}

})